import { DeleteTwoTone, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Col, Dropdown, Menu, message, Modal, Popconfirm, Row, Space, Statistic } from "antd";
import ListTable from "common/ListTable";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PO_WISE_INFO, PURCHAS_ORDER_LIST_NEW, UNIT_PRICE_DELETE } from "../../apiServices/API_ENDPOINTS";
import { deleteData, getData, postData } from "../../apiServices/common";
import { PURCHASE_ORDER_EDIT_PERMISSION, PURCHASE_ORDER_VIEW_PERMISSION } from "../../routes/permissions";
import { hasPermission } from "../../utils/functions";
import { isMobileView } from "../Common/AppHelper";
import CustomFilter from "../Common/CustomFilter";
import Header from "../Common/Header";
import UpdatePOWiseBreakdownModal from "./AddOrUpdateStyle/view/UpdatePOWiseBreakdownModal";

const POWiseBreakdown = (props) => {
  // Props
  const { width } = props;

  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [permitList, setPermitList] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rangeData, setRangeData] = useState();
  const [summaryData, setSummaryData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState({});

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const formatNumberWithCommas = (number) => {
    return Number(parseFloat(number).toFixed(2)).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });
  };

  const columns = [
    {
      title: "Reference No.",
      dataIndex: "reference_no",
      key: "reference_no",
    },
    {
      title: "Buying Office Name",
      dataIndex: "buying_office_name",
      key: "buying_office_name",
    },
    {
      title: "Buyer Name",
      dataIndex: "buyer_name",
      key: "buyer_name",
    },
    {
      title: "Original PO",
      dataIndex: "original_po",
      key: "original_po",
    },
    // {
    //   title: "Sales Order Quantity",
    //   dataIndex: "sales_order_quantity",
    //   key: "sales_order_quantity",
    //   render: (_, record) => formatNumberWithCommas(record?.sales_order_quantity),
    // },
    // {
    //   title: "Total Sales Order Quantity",
    //   dataIndex: "total_sales_order_quantity",
    //   key: "total_sales_order_quantity",
    //   render: (_, record) => formatNumberWithCommas(record?.total_sales_order_quantity),
    // },
    {
      title: "PO Quantity",
      dataIndex: "po_wise_order_quantity",
      key: "po_wise_order_quantity",
      render: (_, record) =>
        record?.po_wise_order_quantity ? formatNumberWithCommas(record?.po_wise_order_quantity) : "N/A",
    },
    {
      title: "PO Value",
      dataIndex: "po_wise_order_price",
      key: "po_wise_order_price",
      render: (_, record) =>
        record?.po_wise_order_price ? formatNumberWithCommas(record?.po_wise_order_price) : "N/A",
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unit_price",
      render: (_, record) => (record?.unit_price ? formatNumberWithCommas(record?.unit_price) : "N/A"),
    },
    {
      title: "Contract Status",
      dataIndex: "contract_status",
      key: "contract_status",
    },
    {
      title: "View",
      key: "view",
      width: "8%",
      render: (_, record) => (
        <Button type="primary" icon={<EyeOutlined />} onClick={() => handleViewClick(record)} size="middle">
          {/* View */}
        </Button>
      ),
    },
    {
      title: "Actions",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <div className="cursore-pointer">
          <Dropdown overlay={menu(record)}>
            <MoreOutlined style={{ fontSize: "20px" }} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const getAllPermitList = useCallback(
    async (passedObject = {}) => {
      setLoading(true);

      const mergedFilters = { ...currentFilters, ...passedObject };
      const { page: requestedPage, ...requestFilter } = mergedFilters || {};

      if (Object.keys(passedObject).length > 0) {
        setCurrentFilters(requestFilter);
      }

      if (requestedPage != null && Number(requestedPage) !== Number(currentPage)) {
        setCurrentPage(Number(requestedPage));
        setLoading(false);
        return;
      }

      const customQuery = `${PURCHAS_ORDER_LIST_NEW}/?page=${currentPage}`;
      const response = await getData(customQuery, false, requestFilter);

      if (response && response?.data?.code === 200) {
        const masterData = response?.data;
        console.log("masterData:", masterData);
        const paginatedData = masterData?.data?.[0];
        setPermitList(paginatedData?.data || []);
        setTotalData(paginatedData?.total || 0);
        setRangeData(paginatedData?.per_page || 10);
        setSummaryData(masterData?.data?.[1]);
      }
      setLoading(false);
    },
    [currentPage, currentFilters],
  );

  useEffect(() => {
    getAllPermitList();
  }, [currentPage, getAllPermitList]);

  const gotoEditRoute = (id, poMapId) => {
    navigate(`/merchandising/update-po-wise-purchase-order-breakdown/${id}/${poMapId}`);
  };

  const handleDelete = (id) => {
    if (!id) return;

    const query = `${UNIT_PRICE_DELETE}/${id}`;

    const response = deleteData(query);

    if (response && response?.code === 200) {
      message.success("Data Deleted Successfully");
      getAllPermitList();
    }
  };

  const handleViewClick = (record) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedRecord(null);
  };

  const menu = (data) => {
    console.log(data);
    return (
      <Menu
        items={[
          {
            label: (
              <div onClick={() => gotoEditRoute(data?.id, data?.po_map_id)}>
                <Button icon={<EditOutlined />} type="text">
                  Edit
                </Button>
              </div>
            ),
            key: "1",
            disabled: !hasPermission([PURCHASE_ORDER_EDIT_PERMISSION]),
          },
          {
            label: (
              <Popconfirm title="Are you sure you want to delete?" onConfirm={() => handleDelete(data?.id)}>
                <Button icon={<DeleteTwoTone />} danger type="text">
                  Delete
                </Button>
              </Popconfirm>
            ),
            key: "2",
            disabled: !hasPermission([PURCHASE_ORDER_VIEW_PERMISSION]),
          },
        ]}
      />
    );
  };

  const paginate = (page) => {
    setCurrentPage(page);
  };

  const extra = (
    <Space>
      <Button
        type={showFilter ? "danger" : "primary"}
        size="small"
        onClick={() => setShowFilter((prev) => !prev)}
        style={{ float: "right" }}
      >
        {`${showFilter ? "Close" : "Open"} Filter Option`}
      </Button>
    </Space>
  );

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        tableData={permitList}
        fetchTableData={(filters) => {
          setCurrentPage(1);
          getAllPermitList(filters);
        }}
        filterName="purchase_order"
      />
    ),
    [showFilter],
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header title="PO Breakdown" subTitle="" actions={extra} />
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          {memoizedCustomFilter}

          {summaryData && (
            <Card
              style={{ marginBottom: 16, marginTop: 10 }}
              loading={loading}
              title="Purchase Order Summary"
              bordered={false}
            >
              <Row gutter={16}>
                <Col span={8}>
                  <Statistic
                    title="Order Price"
                    value={formatNumberWithCommas(summaryData.order_price || 0)}
                    precision={2}
                    suffix=""
                  />
                </Col>
                <Col span={8}>
                  <Statistic
                    title="Order Quantity"
                    value={summaryData.order_quantity || 0}
                    // precision={2}
                    suffix="Pcs"
                  />
                </Col>
              </Row>
            </Card>
          )}
          <ListTable
            loading={loading}
            dataSource={permitList}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>

      <Modal
        title="PO Breakdown Details"
        open={modalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
        ]}
        width={1200}
        styles={{
          body: {
            // overflowY: "auto",
            // maxHeight: "calc(100vh - 200px)",
          },
        }}
      >
        {selectedRecord && <UpdatePOWiseBreakdownModal itemId={selectedRecord.id} poMapId={selectedRecord.po_map_id} />}
      </Modal>
    </Fragment>
  );
};

export default POWiseBreakdown;
